'use strict'
class TextTruncator {
	constructor(textElement, linkText = "Show more", maxLength = 360) {
		this.textElement = document.querySelector(textElement)
		if (!this.textElement) {
			console.error(`Invalid selector: ${textElement}. Please provide a valid DOM element selector.`)
			return
		}
		this.maxLength = maxLength
		this.counter = maxLength
		this.foundTextLimit = false
		this.linkText = linkText || 'Show more'

		this.initialize()
	}

	displayWholeText = (e) => {
		e.preventDefault()
		Array.from(this.textElement.childNodes).forEach((child) => {
			if (child.tagName) {
				if (child.classList.contains('hidden-text')) child.classList.remove('hidden-text')
				if (child.classList.contains('truncated-text')) child.remove()
				if (child.classList.contains('show-more')) child.remove()
			}
		})
	}

	initialize() {
		Array.from(this.textElement.childNodes).forEach((child, index) => {
			//* Filter nodes without tag name
			if (child.tagName) {
				//* Prevent self closing tags
				if (child.innerText.length > 0) {
					if (child.innerText.length < this.counter) {
						//* Calculate length of the current child text and substract it from the counter
						this.counter -= child.innerText.length
					} else if (!this.foundTextLimit) { //* If limit is reached for the 1st time ...

						//* substract string inner text from more than remaining counter value
						//* and prevent truncated last word
						let truncatedText = child.innerText.substring(0, this.counter)
						const lastSpaceIndex = truncatedText.lastIndexOf(' ')
						truncatedText = truncatedText.trim().substring(0, lastSpaceIndex)
						// console.log("child.localName:", child.localName)

						//* Hide child
						child.classList.add('hidden-text')

						//* Create a new span tag to display ellipsis truncated text and a link to show more
						const newSpan = document.createElement(child.localName)
						newSpan.classList.add('truncated-text')
						newSpan.innerText = `${truncatedText} ...`
						child.parentElement.insertBefore(newSpan, child)

						const showMoreLink = document.createElement('a')
						const svgArrow = '<span class="icon-wrap"><svg viewBox="0 0 14 10" fill="none" aria-hidden="true" focusable="false" class="icon icon-arrow" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M8.537.808a.5.5 0 01.817-.162l4 4a.5.5 0 010 .708l-4 4a.5.5 0 11-.708-.708L11.793 5.5H1a.5.5 0 010-1h10.793L8.646 1.354a.5.5 0 01-.109-.546z" fill="currentColor"></path></svg></span>'
						showMoreLink.href = '#'
						showMoreLink.innerHTML = this.linkText + svgArrow
						showMoreLink.style.display = 'block'
						showMoreLink.classList.add('show-more', 'animate-arrow')
						showMoreLink.addEventListener('click', this.displayWholeText)
						child.parentElement.insertBefore(showMoreLink, child.nextSibling)

						this.foundTextLimit = true
						this.counter = 0
					}
				}
				//* Then add a display none class to the rest of the children
				if (this.foundTextLimit) child.classList.add('hidden-text')
			}
		})
	}
}
